// create and export a method to return a hex color from a list based on a zero based index. if we go past the array length we should return grey
import { chartColors } from './chart-colors.js'
export const defaultPalette = chartColors

const palettes = {
	default: defaultPalette
}

const localStorageKey = 'selectedChartPalette'
const customColorsKey = 'chartColors'

// Cache for custom colors to avoid repeated localStorage reads
let cachedCustomColors = null
let cacheTimestamp = 0
const CACHE_DURATION = 1000 // 1 second cache

/**
 * Get custom colors from localStorage with caching
 * @returns {string[]|null} Custom colors array or null if not set
 */
function getCustomColors () {
	const now = Date.now()

	// Return cached value if still valid
	if (cachedCustomColors !== null && (now - cacheTimestamp) < CACHE_DURATION) {
		return cachedCustomColors
	}

	try {
		const stored = localStorage.getItem(customColorsKey)
		if (stored) {
			const parsed = JSON.parse(stored)
			if (Array.isArray(parsed) && parsed.length >= 8) {
				cachedCustomColors = parsed
				cacheTimestamp = now
				return parsed
			}
		}
	} catch (e) {
		if (e instanceof SyntaxError) {
			console.error('Corrupted chart colours in localStorage, clearing:', e.message)
			// Clear corrupted data
			try {
				localStorage.removeItem(customColorsKey)
			} catch (removeError) {
				// Ignore removal errors
			}
		} else {
			console.warn('Could not access localStorage for chart colours:', e.message)
		}
	}

	cachedCustomColors = null
	cacheTimestamp = now
	return null
}

/**
 * Clear the custom colors cache (call after saving new colors)
 */
export function clearCustomColorsCache () {
	cachedCustomColors = null
	cacheTimestamp = 0
}

export function getChartColorByIndex (index, paletteName = null) {
	// First, check for custom colors in localStorage
	const customColors = getCustomColors()
	if (customColors && customColors.length > 0) {
		const effectiveIndex = index % customColors.length
		return customColors[effectiveIndex]
	}

	// Fall back to palette-based colors
	let selectedPaletteName = paletteName

	if (!selectedPaletteName) {
		try {
			selectedPaletteName = localStorage.getItem(localStorageKey)
		} catch (e) {
			console.warn('Could not access localStorage. Using default palette.')
			selectedPaletteName = 'default'
		}
	}

	const currentPalette = palettes[selectedPaletteName] || palettes.default

	if (!currentPalette || currentPalette.length === 0) {
		// Return a default color or throw an error if the array is unexpectedly empty
		return '#808080' // Default to grey as a safe fallback
	}
	const effectiveIndex = index % currentPalette.length
	return currentPalette[effectiveIndex]
}
